import React from "react";

interface LoadingModalProps {
  isOpen: boolean;
  message?: string;
}

export const LoadingModal: React.FC<LoadingModalProps> = ({
  isOpen,
  message = "Creating Your Digital Card...",
}) => {
  if (!isOpen) return null;

  return (
    <div className="loading-modal">
      <div className="loading-modal-content">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
        </div>

        <h2 className="loading-title">Please wait</h2>
        <p className="loading-message">{message}</p>

        <div className="loading-progress">
          <div className="progress-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
